
import React from 'react';

interface FeatureItemProps {
  feature: {
    icon: React.ReactNode;
    title: string;
    description: string;
    color: string;
  };
  index: number;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ feature, index }) => {
  return (
    <div className="flex items-start space-x-4">
      <div className={`p-2 rounded-lg bg-gradient-to-br ${feature.color} text-white`}>
        {feature.icon}
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">
          {feature.title}
        </h3>
        <p className="text-gray-600 text-sm">
          {feature.description}
        </p>
      </div>
    </div>
  );
};

export default FeatureItem;
